import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import { LuPackageSearch} from "react-icons/lu";
import {SiSearxng} from "react-icons/si";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {HiOutlineQrcode} from "react-icons/hi";
import {FaEye} from "react-icons/fa";
import {useNavigate, useParams} from "react-router-dom";
import {IoMdCheckmarkCircleOutline} from "react-icons/io";

function SearchProduct() {
    const {code} = useParams();
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(true);
    const [data, setData] = React.useState(null);
    const [theCode, setTheCode] = React.useState('');
    React.useEffect(() => {
        if (code.length > 5) {

            setIsLoaded(false);
            API.getProduct(code)
                .then((response) => {
                    setIsLoaded(true);
                    setData(response.data)

                })
                .catch((error) => {
                    setIsLoaded(true);
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
        else {
            setIsLoaded(true);
        }
    }, [code]);


    return (
        <React.Fragment>
            <Navbar page="battery"/>
            <Header/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }


            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <SiSearxng className='ms-2' />
                    جستجوی باتری
                    </h1>

                </div>

                <section className="section">
                    <div className="row">

                        <div className="col-12">

                            <div className="card">
                                <div className="card-body py-4">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-floating mb-3">
                                                <input type="number" className="form-control text-center"
                                                       id="floatingInput" placeholder="کد"
                                                       autoFocus={true}
                                                       value={theCode}
                                                       onChange={(val) => {
                                                           setTheCode(val.target.value)
                                                       }}
                                                />
                                                <label htmlFor="floatingInput">کد باتری</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            &nbsp;
                                        </div>
                                        <div className="col-md-4 pt-2">
                                            <button className="btn btn-warning w-100 py-2"
                                                    onClick={() => {
                                                        navigate('/product/' + theCode)
                                                    }}
                                            >
                                                جستجو
                                                <LuPackageSearch className='float-start mt-1'/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-12">

                            <div className="card">
                                {
                                    data &&
                                    <div className="card-body py-4">

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                کد یکتای باتری:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.code}
                                            </div>
                                        </div>


                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                برند:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.brand}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                آمپراژ:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.amperage}
                                                <span className='me-2 text-small-2 text-muted'>
                                                آمپر
                                            </span>
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                گروه فرعی:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.secondary_group}

                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                وضعیت:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2"
                                                 style={{color: data?.last_status?.color}}
                                            >
                                                {data?.last_status?.title}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                تاریخ شروع گارانتی:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.warranty_start_date}
                                            </div>
                                        </div>


                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                نماینده
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.vendor}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                تاریخ پایان گارانتی:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.warranty_end_date}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                تعداد روزهای باقی مانده:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.remaining}
                                                &nbsp;
                                                روز
                                            </div>
                                        </div>
                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                مشتری:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.customer}
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                سفارش مربوطه:
                                            </div>
                                            {
                                                data?.order?.id &&
                                                <div className="col-md-6 col-12 text-start fw-bold text-small-2 "
                                                     onClick={
                                                         () => {
                                                             navigate(`/orders/${data?.order?.id}`)
                                                         }
                                                     }
                                                     role='button'
                                                >
                                                <span className='btn btn-outline-success'><FaEye
                                                    className='mx-2 text-big-2 text-primary'/>
                                                    {data?.order?.tracking_code}</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                کد پالت:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                               <span className='btn btn-outline-info'
                                                     onClick={() => navigate('/pallet/' + data?.pallet_code)}>
                                                    {data?.pallet_code}
                                                   <FaEye className='mx-2 text-big-2 '/>
                                               </span>
                                            </div>
                                        </div>
                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className="col-md-5 col-10 text-small-2">
                                                باتری جایگزین:
                                            </div>
                                            <div className="col-md-6 col-12 text-start fw-bold text-small-2">
                                                {data?.alternate_product ?
                                                    <span className='fw-bold  btn btn-outline-danger' role='button'
                                                          onClick={() => navigate('/product/' + data?.alternate_product)}
                                                    >

                                                    {data?.alternate_product}
                                                        <FaEye className='mx-2 text-big-2 '/>
                                                </span> :
                                                    <span></span>
                                                }
                                            </div>
                                        </div>

                                        <div className="row mx-2 mb-3 border-bottom pb-2">
                                            <div className="col-1">
                                                <HiOutlineQrcode/>
                                            </div>
                                            <div className=" col-11 text-small-2">
                                                اطلاعات فنی باتری:
                                            </div>
                                            <div className="col-2">
                                                &nbsp;
                                            </div>
                                            <div className="col-10 px-4 py-2 text-big-2 text-center">


                                            <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       اسید:
                                                &nbsp;
                                                {data?.properties[0]?.acid}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       تیپ باتری:
                                                    &nbsp;
                                                    {data?.properties[0]?.battery_type}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       نوع بازکاری:
                                                    &nbsp;
                                                    {data?.properties[0]?.open_work}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                        خط:
                                                    &nbsp;
                                                    {data?.properties[0]?.produce_line}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                        نوع صفحه:
                                                    &nbsp;
                                                    {data?.properties[0]?.sheet}
                                   </span>
                                                <span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       نوع سپراتور:
                                                    &nbsp;
                                                    {data?.properties[0]?.separator}
                                   </span><span className='badge badge-pill badge-primary bg-secondary mx-2 '>
                                       وان:
                                                    &nbsp;
                                                    {data?.properties[0]?.tub_number}
                                   </span>


                                            </div>
                                        </div>

                                    </div>
                                }
                            </div>

                        </div>
                        {
                            data &&
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">تاریخچه وضعیت های باتری</h5>
                                    <div className="row">
                                        {
                                            data?.status_history?.map(stat => {
                                                return (
                                                    <div className='col-12 mt-2 bg-light text-small-1  p-2'>
                                                        <IoMdCheckmarkCircleOutline className='mx-2'
                                                                                    style={{color: stat.status.color}}
                                                        />
                                                        باتری در تاریخ:
                                                        &nbsp;
                                                        {stat.date}
                                                        &nbsp;
                                                        توسط
                                                        &nbsp;
                                                        <strong>{stat.operator.length > 2 ? stat.operator : stat.backend_user}</strong>
                                                        &nbsp;

                                                        در وضعیت
                                                        &nbsp;
                                                        <span className='fw-bold' style={{color: stat.status.color}}>
                                                            {stat.status.title}
                                                        </span>

                                                        &nbsp;
                                                        قرار گرفت.

                                                        <div className='fw-bold text-muted me-4 text-small-2 mt-3'>
                                                            {stat.description?.length > 2 ? stat.description : ''}
                                                        </div>
                                                    </div>
                                                )

                                            })

                                        }
                                    </div>

                                </div>
                            </div>

                        </div>
                        }
                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default SearchProduct;